module.exports = __webpack_public_path__ + "img/m_3.024b93f0.png";